module.exports = __webpack_public_path__ + "img/936732f.jpg";